"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SWITCH_THEME = exports.TOGGLE_MOBILE_NAV = exports.HEADER_NAV_COLOR_CHANGE = exports.TOP_NAV_COLOR_CHANGE = exports.NAV_TYPE_CHANGE = exports.SIDE_NAV_STYLE_CHANGE = exports.CHANGE_LOCALE = exports.TOGGLE_COLLAPSED_NAV = void 0;
var TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
exports.TOGGLE_COLLAPSED_NAV = TOGGLE_COLLAPSED_NAV;
var CHANGE_LOCALE = 'CHANGE_LOCALE';
exports.CHANGE_LOCALE = CHANGE_LOCALE;
var SIDE_NAV_STYLE_CHANGE = 'SIDE_NAV_STYLE_CHANGE';
exports.SIDE_NAV_STYLE_CHANGE = SIDE_NAV_STYLE_CHANGE;
var NAV_TYPE_CHANGE = 'NAV_TYPE_CHANGE';
exports.NAV_TYPE_CHANGE = NAV_TYPE_CHANGE;
var TOP_NAV_COLOR_CHANGE = 'TOP_NAV_COLOR_CHANGE';
exports.TOP_NAV_COLOR_CHANGE = TOP_NAV_COLOR_CHANGE;
var HEADER_NAV_COLOR_CHANGE = 'HEADER_NAV_COLOR_CHANGE';
exports.HEADER_NAV_COLOR_CHANGE = HEADER_NAV_COLOR_CHANGE;
var TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';
exports.TOGGLE_MOBILE_NAV = TOGGLE_MOBILE_NAV;
var SWITCH_THEME = 'SWITCH_THEME';
exports.SWITCH_THEME = SWITCH_THEME;